module.exports = __webpack_public_path__ + "static/img/fyjs.faa160cd.png";